var _path, _circle, _circle2, _circle3, _circle4, _circle5, _ellipse, _path2, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0483 111.999H47.9677C51.8604 111.999 55.016 108.843 55.016 104.95V100.415C55.016 98.9704 54.5819 97.5532 53.5876 96.5059C51.362 94.1616 46.6199 90.212 39.9563 90.2463C33.3039 90.2806 28.6177 94.189 26.4178 96.5121C25.4297 97.5554 25 98.966 25 100.403V104.95C25 108.843 28.1556 111.999 32.0483 111.999Z",
    fill: "#CB7D57"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0071,
    cy: 80.343,
    r: 11.9699,
    fill: "#CB7D57"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.175,
    cy: 78.7629,
    r: 3.09882,
    fill: "#F1F1F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.175,
    cy: 78.7629,
    r: 3.09882,
    fill: "#F1F1F1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4758,
    cy: 78.7629,
    r: 3.09882,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4758,
    cy: 78.7629,
    r: 3.09882,
    fill: "#F1F1F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.989,
    cy: 57.253,
    rx: 25.6627,
    ry: 16.253,
    fill: "#C6B0A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2051 79.7079C82.6557 76.6284 91.0103 70.2983 93.0063 67.5182L82.7412 60.8887C81.3725 68.5875 70.4802 76.6427 65.2051 79.7079Z",
    fill: "#C6B0A6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.8311,
    cy: 57.0733,
    r: 2.38582,
    fill: "#F1F1F1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.808,
    cy: 57.0733,
    r: 2.38582,
    fill: "#F1F1F1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.501,
    cy: 57.0733,
    r: 2.38582,
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInt2);
export default __webpack_public_path__ + "static/media/int-2.887d64dcfe9189a9573e92cf64e169c8.svg";
export { ForwardRef as ReactComponent };